<template>
  <div class="map-container" v-loading="loading">
    <private-tips />
    <private-bar
      @searchAction="searchAction"
      @searchVT="searchVT"
      @clearVT="clearVT"
    />
    <div id="map-container"></div>
  </div>
</template>

<script>
import PrivateBar from "./bar";
import PrivateTips from "./tips";
import car from "@/assets/images/car-1.png";
import car2 from "@/assets/images/car-2.png";
import car3 from "@/assets/images/car-3.png";
import carWarn from "@/assets/images/car-warn.png";
import {
  GetCarList,
  queryCarCoordinate,
  queryTraceCarCoordinate,
  getVehicleTrace
} from "@/api/home";

let map = null;
let mass = null;
let timeId = null;
let flag = true;
//定义一些常量
let x_PI = (3.14159265358979324 * 3000.0) / 180.0;
let PI = 3.1415926535897932384626;
let a = 6378245.0;
let ee = 0.00669342162296594323;
export default {
  components: { PrivateBar, PrivateTips },
  data () {
    return {
      data: null,
      sn: [],
      Marker: {},
      loading: false,
      pointData: [],
      searchSn: "",
      circle: {}
    };
  },
  mounted () {
    this.mapInit();
    this.Emit.$on("refreshData", this.refreshData); //点击刷新
    this.Emit.$on("setupTime", this.setupTime); //设置刷新时间
    this.Emit.$on("closeInterval", this.closeInterval); //关闭任务
    // this.Emit.$on("searchAction", this.searchAction);
  },
  beforeDestroy () {
    //离开页面时销毁定时任务
    clearInterval(timeId);
    //关闭
    timeId = null;
  },
  destroyed () {
    this.Emit.$off("refreshData"); //刷新功能在页面离开时销毁
    this.Emit.$off("setupTime"); //设置刷新时间
    this.Emit.$off("closeInterval"); //关闭
    // this.Emit.$off("searchAction"); //
  },
  methods: {
    searchAction (search) {
      // console.log(search)
      this.loading = true;
      this.searchSn = "";
      this.getData(search).finally(() => {
        this.loading = false
      })
      //清理上次标点
      // if (mass != null) {
      //   map.remove(mass);
      //   mass = null;
      // }
      // if (this.isNotEmpty(search.value)) {
      //   queryTraceCarCoordinate({ licenseNum: search.value }).then(res => {
      //     this.pointData = [];
      //     if (res.code == 0) {
      //       this.searchSn = res.data.sn;
      //       let i = 0;
      //       res.data.coordinate.forEach(el => {
      //         let point = {
      //           lnglat: [el.longitude, el.latitude],
      //           name: "",
      //           style: 2
      //         };
      //         this.pointData.push(point);
      //       });

      //       //根据历史数据标点
      //       let style = [
      //         {
      //           url: "https://a.amap.com/jsapi_demos/static/images/mass1.png",
      //           anchor: new AMap.Pixel(6, 6),
      //           size: new AMap.Size(11, 11)
      //         }
      //       ];

      //       var marker = new AMap.Marker({ content: " ", map: map });
      //       mass = new AMap.MassMarks(this.pointData, {
      //         opacity: 0.8,
      //         zIndex: 111,
      //         cursor: "pointer",
      //         style: style
      //       });

      //       mass.on("mouseover", function (e) {
      //         marker.setPosition(e.data.lnglat);
      //         marker.setLabel({ content: e.data.name });
      //       });

      //       mass.setStyle(style);
      //       // mass.setMap(map);

      //       //去掉其他车辆
      //       this.addMarkers();
      //       this.loading = false;
      //     } else if (res == "fallback") {
      //       this.$message.error("请求超时");
      //     }
      //     this.loading = false;
      //   });
      // } else {
      //   if (mass != null) {
      //     // mass.setMap(null);
      //     map.remove(mass);
      //     mass = null;
      //     this.circle.setMap(null); //删除圆圈
      //     mass = null;
      //   }

      //   this.searchSn = "";
      //   map.setCenter([109.189395, 36.300634]);
      //   map.setZoom(5);

      //   this.addMarkers();
      //   this.loading = false;
      // }
    },
    searchVT (val) {
      this.loading = true;
      getVehicleTrace(val).then(da => {
        let lineArr = []
        da.data.coordinate.map(item => {
          lineArr.push([item.longitude, item.latitude])
        })
        map.setCenter(lineArr[0])
        this.polyline = new AMap.Polyline({
          map: map,
          path: lineArr,
          showDir: true,
          strokeColor: "#28F",  //线颜色
          // strokeOpacity: 1,     //线透明度
          strokeWeight: 6,      //线宽
          // strokeStyle: "solid"  //线样式
        });
      }).finally(() => {
        this.loading = false;
      })
    },
    clearVT () {
      map.remove(this.polyline);
      this.polyline = null
    },
    mapInit () {
      map = new AMap.Map("map-container", {
        //viewMode: "3D",
        // center: [120.75, 30.75],
        center: [109.189395, 36.300634],
        zoom: 5,
        mapStyle: "amap://styles/darkblue"
        // showLabel: false
      });
      this.getData(); //上来就获取下数据
    },

    //刷新
    refreshData () {
      this.getData();
    },

    //关闭定时任务
    closeInterval () {
      //销毁定时任务
      clearInterval(timeId);
      //关闭
      timeId = null;
    },

    //设置定时刷新时间
    setupTime (value) {
      this.createTimeTask(value.value);
    },

    //上来就获取下数据
    getData (parmas) {
      return GetCarList(parmas).then(res => {
        if (res.code == 0) {
          this.data = res.data; //获取数据
          this.addMarkers(); //车辆标点
          this.createTimeTask(30000);
        }
      });
    },

    //每隔多少秒调一下实时数据服务
    createTimeTask (times) {
      clearInterval(timeId);
      timeId = setInterval(() => {
        this.queryCarTimeData();
      }, times);
    },

    //实时查询车辆坐标数据
    queryCarTimeData () {
      let paramArr = [];
      this.data.forEach(ret => {
        this.sn.push(ret.sn);
      });
      paramArr = this.uniqueData(this.sn);
      const param = JSON.stringify(paramArr);
      this.queryCarlocation(param);
    },

    addMarkers () {
      map.clearMap();
      if (this.polyline) {
        map.add(this.polyline)
      }
      const _this = this;
      if (null != this.data && this.data.length > 0) {
        let carList = [];
        let removeMarkers = [];
        this.data.forEach(element => {
          //根据车辆状态查询图标信息
          let iconInfo = this.findMapIcon(element.carType);
          let zIndex = this.findMapIconzIndex(element.carType);
          if (element.lat != null && element.long != null) {
            const reszb = _this.wgs84togcj02(element.long, element.lat);
            const newLong = reszb[0];
            const newLat = reszb[1];
            let marker = new AMap.Marker({
              position: new AMap.LngLat(newLong, newLat),
              zIndex: zIndex,
              icon: iconInfo
            });

            marker.on("click", () => {
              // console.log(element)
              this.loading = true;
              this.$parent.openCarDialog(element.frame_num);
              this.loading = false;
            });
            this.Marker[element.frame_num] = marker;
            carList.push(marker);

            // //按车牌号查询时清除其他车辆点
            if (this.isNotEmpty(this.searchSn) && this.searchSn != element.sn) {
              removeMarkers.push(marker);
            }

            if (this.isNotEmpty(this.searchSn) && this.searchSn == element.sn) {
              // //已查询到的车辆为中心画半径
              this.circle = new AMap.Circle({
                center: new AMap.LngLat(element.long, element.lat), // 圆心位置
                radius: 30000, //半径
                strokeColor: "#e7ecf100", //线颜色
                strokeOpacity: 0.7, //线透明度
                strokeWeight: 1, //线宽
                fillColor: "#b6c7d8", //填充色
                fillOpacity: 0.1 //填充透明度
              });
              this.circle.setMap(map); //显示圆圈
              //map.setFitView();//根据地图上添加的覆盖物分布情况，自动缩放地图到合适的视野级别
              map.setCenter([element.long, element.lat]);
              map.setZoom(15);
            }
          }
        });
        map.add(carList);
        map.remove(removeMarkers);
        if (this.data.length === 1) {
          map.setCenter([this.data[0].long, this.data[0].lat]);
        }
      }
    },
    //实时查询车辆经纬度并更新到地图
    queryCarlocation (param) {
      if (!flag) {
        //避免不同时间的定时任务重复调用
        return;
      }
      flag = false;
      queryCarCoordinate({ sn: param }).then(res => {
        flag = true;
        if (res.code == 0) {
          //实时数据
          res.data.forEach(el => {
            //根据车辆状态码获取车辆图标
            let icon = this.findMapIcon(el.carType);
            let sn = el.sn;
            let long = el.longitude;
            let lat = el.latitude;
            //初始数据
            this.data.forEach(carRes => {
              let frame_num = carRes.frame_num;
              let longitude = carRes.long;
              let latitude = carRes.lat;
              //实时数据经纬度更新
              if (
                this.isNotEmpty(frame_num) &&
                frame_num == sn &&
                this.isNotEmpty(long) &&
                this.isNotEmpty(lat)
              ) {
                this.Marker[el.sn].setPosition(
                  new AMap.LngLat(el.longitude, el.latitude)
                );
              }
              //实时数据车辆状态更新
              if (
                this.isNotEmpty(frame_num) &&
                frame_num == sn &&
                this.isNotEmpty(icon)
              ) {
                this.Marker[el.sn].setIcon(icon);
              }
            });
          });
        }
      });
      this.addMarkers();
    },
    //数组去重
    uniqueData (arr) {
      if (!Array.isArray(arr)) {
        console.log("type error!");
        return;
      }
      arr = arr.sort();
      var arrry = [arr[0]];
      for (var i = 1; i < arr.length; i++) {
        if (arr[i] !== arr[i - 1]) {
          arrry.push(arr[i]);
        }
      }
      return arrry;
    },
    //匹配图标
    findMapIcon (carType) {
      let carIcon = "";
      let carIcon1 = new AMap.Icon({
        image: car,
        size: new AMap.Size(27, 13),
        imageSize: new AMap.Size(27, 13)
      });
      let carIcon2 = new AMap.Icon({
        image: car2,
        size: new AMap.Size(27, 13),
        imageSize: new AMap.Size(27, 13)
      });
      let carIcon3 = new AMap.Icon({
        image: car3,
        size: new AMap.Size(27, 13),
        imageSize: new AMap.Size(27, 13)
      });
      let carWarnIcon = new AMap.Icon({
        image: carWarn,
        size: new AMap.Size(18, 18),
        imageSize: new AMap.Size(18, 18)
      });
      if (carType == "1") {
        carIcon = carIcon1;
      } else if (carType == "2") {
        carIcon = carIcon2;
      } else if (carType == "3") {
        carIcon = carIcon3;
      } else if (carType == "4") {
        carIcon = carWarnIcon;
      }
      return carIcon;
    },
    findMapIconzIndex (carType) {
      let zIndex = 0;
      if (carType == "1") {
        zIndex = 9999;
      } else if (carType == "2") {
        zIndex = 999;
      } else if (carType == "3") {
        zIndex = 99;
      } else if (carType == "4") {
        zIndex = 9;
      }
      return zIndex;
    },
    //非空判断
    isNotEmpty (str) {
      // console.log(str)
      if (str != null && str != "" && str.trim().length > 0) {
        return true;
      }
      return false;
    },

    //坐标转换

    wgs84togcj02 (lng, lat) {
      const _this = this;
      var lat = +lat;
      var lng = +lng;
      if (_this.out_of_china(lng, lat)) {
        return [lng, lat];
      } else {
        var dlat = _this.transformlat(lng - 105.0, lat - 35.0);
        var dlng = _this.transformlng(lng - 105.0, lat - 35.0);
        var radlat = (lat / 180.0) * PI;
        var magic = Math.sin(radlat);
        magic = 1 - ee * magic * magic;
        var sqrtmagic = Math.sqrt(magic);
        dlat = (dlat * 180.0) / (((a * (1 - ee)) / (magic * sqrtmagic)) * PI);
        dlng = (dlng * 180.0) / ((a / sqrtmagic) * Math.cos(radlat) * PI);
        var mglat = lat + dlat;
        var mglng = lng + dlng;
        return [mglng, mglat];
      }
    },
    transformlat (lng, lat) {
      var lat = +lat;
      var lng = +lng;
      var ret =
        -100.0 +
        2.0 * lng +
        3.0 * lat +
        0.2 * lat * lat +
        0.1 * lng * lat +
        0.2 * Math.sqrt(Math.abs(lng));
      ret +=
        ((20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) *
          2.0) /
        3.0;
      ret +=
        ((20.0 * Math.sin(lat * PI) + 40.0 * Math.sin((lat / 3.0) * PI)) *
          2.0) /
        3.0;
      ret +=
        ((160.0 * Math.sin((lat / 12.0) * PI) +
          320 * Math.sin((lat * PI) / 30.0)) *
          2.0) /
        3.0;
      return ret;
    },

    transformlng (lng, lat) {
      var lat = +lat;
      var lng = +lng;
      var ret =
        300.0 +
        lng +
        2.0 * lat +
        0.1 * lng * lng +
        0.1 * lng * lat +
        0.1 * Math.sqrt(Math.abs(lng));
      ret +=
        ((20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) *
          2.0) /
        3.0;
      ret +=
        ((20.0 * Math.sin(lng * PI) + 40.0 * Math.sin((lng / 3.0) * PI)) *
          2.0) /
        3.0;
      ret +=
        ((150.0 * Math.sin((lng / 12.0) * PI) +
          300.0 * Math.sin((lng / 30.0) * PI)) *
          2.0) /
        3.0;
      return ret;
    },
    out_of_china (lng, lat) {
      var lat = +lat;
      var lng = +lng;
      // 纬度3.86~53.55,经度73.66~135.05
      return !(lng > 73.66 && lng < 135.05 && lat > 3.86 && lat < 53.55);
    }
  }
};
</script>

<style lang="less" scoped>
.map-container {
  position: relative;
  width: 100%;
  height: 100%;
  #map-container {
    width: 100%;
    height: 100%;
  }
}
</style>
